export default __webpack_public_path__ + "static/media/pulse.ed941cc8.png";